import { gsap } from './gsap';

export function initRobotsShowcase() {
    const section = document.querySelector( '.robots-showcase' );
    if ( ! section ) return;

    const items    = section.querySelectorAll( '[data-robot-item]' );
    const imgWraps = section.querySelectorAll( '[data-robot-image]' );

    if ( ! items.length ) return;

    const isMobile = window.innerWidth <= 768;

    if ( ! isMobile ) {
        // Hover: swap images
        items.forEach( ( item ) => {
            const id      = item.dataset.robotItem;
            const imgWrap = section.querySelector( `[data-robot-image="${ id }"]` );
            if ( ! imgWrap ) return;

            item.addEventListener( 'mouseenter', () => {
                imgWraps.forEach( ( w ) => gsap.set( w, { opacity: 0 } ) );
                gsap.set( imgWrap, { opacity: 1 } );
            } );

            item.addEventListener( 'mouseleave', () => {
                gsap.set( imgWrap, { opacity: 0 } );
            } );
        } );
    }
}
